module.exports = __webpack_public_path__ + "img/c13.13ea52bb.png";